import {useEffect} from "react";
import {Outlet, useLocation} from "react-router";
import {getPageTitle} from "router/getNavigation";
import {capitalize} from "utils/values";

const getBaseDomain = (hostname: string): string => {
  const parts = hostname.split(".");

  // admin.<domain>.<TLD> -> take the second part (domain)
  return parts[1];
};

const AppTitle = () => {
  const {pathname} = useLocation();
  const baseDomain = capitalize(getBaseDomain(window.location.hostname));

  useEffect(() => {
    // Remove leading slash and get page title from navigation data
    const pathSegment = pathname.slice(1);
    const pageTitle = getPageTitle(pathSegment);

    document.title = pageTitle ? `${baseDomain} | ${pageTitle}` : baseDomain;
  }, [pathname, baseDomain]);

  return null;
};

const GlobalLayout = () => (
  <>
    <AppTitle />
    <Outlet />
  </>
);

export default GlobalLayout;
